export default __webpack_public_path__ + "static/media/ms-excel.23585815.svg";